import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { DisponibiliteFormdata, IDisponibilite } from './disponibilite.type';

const DisponibiliteApi = createApi({
    reducerPath: "disponibiliteApi",
    tagTypes: ["disponibilite"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        addDisponibilite: build.mutation<
            IDisponibilite,
            { slug?: string; data: IDisponibilite }
        >({
            query: ({ slug, data }) => ({
                url: slug ? `disponibilites/${slug}/` : `disponibilites/`,
                method: slug ? "PUT" : "POST",
                body: data,
            }),
            invalidatesTags: ["disponibilite"],
        }),
        getDisponibilites: build.query<PaginationResults<IDisponibilite>, TypeQuery>({
            query: () => `disponibilites/`,
            providesTags: ["disponibilite"],
        }),
        deleteDisponibilite: build.mutation<DisponibiliteFormdata, string>({
            query: (slug) => ({
                url: `disponibilites/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["disponibilite"],
        }),
    }),
});

export default DisponibiliteApi

export const {
    useAddDisponibiliteMutation,
    useGetDisponibilitesQuery,
    useDeleteDisponibiliteMutation
} = DisponibiliteApi;